import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  count?: number;
  total?: number;
  subtitle?: string;
  actions?: ReactNode;
}

export default function PageHeader({ title, count, total, subtitle, actions }: PageHeaderProps) {
  const countLabel =
    count == null ? null : total != null && total !== count ? `${count} / ${total}` : String(count);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        mb: 2,
      }}
    >
      <Box>
        <Typography variant="h4" component="h1">
          {title}
          {countLabel != null && (
            <Typography component="span" color="text.secondary" sx={{ ml: 1, fontWeight: 500 }}>
              {countLabel}
            </Typography>
          )}
        </Typography>
        {subtitle && (
          <Typography color="text.secondary" sx={{ mt: 0.5, fontSize: 13 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box>}
    </Box>
  );
}
